import React from 'react'

import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { PATH_NAME } from 'constants/routes';
import { useCreateMenu } from 'api/menuApi';

import { Notification } from 'components/Notification';
import { ContentWrapper } from 'components/layout'

import { MenuForm } from './components/MenuForm'

export default function AddMenu() {
  const intl = useIntl();
  const navigate = useNavigate();

  const createMutation = useCreateMenu();

  const handleSubmit = (values) => {
    createMutation.mutate(values, {
      onSuccess(response) {
        Notification(
          'success',
          intl.formatMessage({
            id: `message.createSuccess`,
          }),
        );

        navigate(`/${PATH_NAME.MENU}/${response.id}`);
      },
      onError(error) {
        Notification(
          'error',
          error.message ?? intl.formatMessage({ id: 'message.commonError' }),
        );
      },
    });
  };

  return (
    <ContentWrapper title={'Tạo mới'}>
        <MenuForm
          onSubmit={handleSubmit}
          isLoading={createMutation.isLoading}
        />
    </ContentWrapper>
  )
}